module.exports = __webpack_public_path__ + "static/img/thank-you.967a973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/old2/thank-you.png
// module id = Gwjp
// module chunks = 0